// extracted by mini-css-extract-plugin
export var caretAnchor = "_vb-0";
export var dropdownContent = "_vb-1";